import React, { useEffect } from 'react'
import Button from 'components/atoms/Button'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import forgotPasskey from '../../../assets/svg/forgotPassKey.svg'
import arrowLeft from '../../../assets/svg/larrow-left-long.svg'
import PageTitle from 'components/atoms/PageTitle'

const PasswordReset = () => {
    const navigate = useNavigate();
    const location: any = useLocation();

    const newValidPassword = location?.state?.newPassword !== undefined ? true : false;

    useEffect(() => {
        if (newValidPassword === false) {
            navigate('/auth/forgot_password');
        }
    }, [navigate, location]);

    return (
        <form onSubmit={() => { }}>
            <img src={forgotPasskey} alt='forgotPasskey' className='w-[40px] h-[40px] mb-3' />
            <PageTitle
                pageTitle='Password reset'
                pageTitleStyle='font-semibold !text-2xl tablet:!text-xl'
                subTitle='Your password has been successfully reset. Click below to return to Login.'
                subTitleStyle='!text-[16px] leading-7 !text-Black2'
            />
            <span>
                <Button
                    btnType='submit'
                    btnText='Return to Login'
                    btnStyle="bg-black text-white px-6 py-3 mt-12 w-full"
                    onClick={() => navigate('/auth/login')}
                />
            </span>
            {/* <span className="flex justify-start items-center gap-3 mt-3 font-semibold text-black text-sm leading-7 cursor-pointer hover:underline hover:transition-all" onClick={() => navigate('/auth/login')}>
                <img src={arrowLeft} alt='arrowLeft' className='w-4 h-4' />
                Back to Login
            </span> */}
        </form>
    )
}

export default PasswordReset